import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Draggable from 'react-draggable'
import { VideoPlayer } from '../../../../legacy'
import mobileDetect from 'aria-viewer/utils/mobileDetect'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'

// Torch this code with gasoline at the earliest opportunity

const isMobile = mobileDetect.mobile()

const S = {
    currentTime: {
        display: 'inline-block',
        float: 'left',
    },
    totalTime: {
        display: 'inline-block',
        float: 'right',
    },
}

class VideoScrubBar extends PureComponent {
    static propTypes = {
        player: PropTypes.object.isRequired,
    }

    static contextTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    }

    static defaultProps = {
        height: 4,
        markerWidth: 24,
        markerHeight: 24,
    }

    constructor(props) {
        super(props)
        this.dragging = false
        this.state = {
            percent: 0,
        }
    }

    init = (props, nextProps) => {
        if (props !== nextProps || props.player !== nextProps.player) {
            nextProps.player.onProgress(this.handleOnProgress.bind(this))
            nextProps.player.onBuffer(this.handleOnBuffer)
        }
        this.updateWidth()
    }

    componentWillMount() {
        this.init(null, this.props)
    }

    // updateVideoProgress = () => {
    //     setInterval(this.props.setVideoProgress, 1000)
    // }

    handleOnProgress = ({ seconds, duration, percent }) => {
        const { player } = this.props
        if (!this.dragging && !this.progressClicked && this.refs.marker) {
            const percent = player.getProgressInfo().percent
            this.refs.marker.setState({ x: percent * Number.parseInt(this.width) })
            this.setState({ percent })
        }
    }

    componentDidUpdate(prevProps) {
        const { isVideoPlaying, progress, stopVideo, percent } = this.props

        this.refs.marker && this.refs.marker.setState({ x: percent * Number.parseInt(this.width) })

        // if (!prevProps.isVideoPlaying && isVideoPlaying) {
        //     this.updateVideoProgress()
        // }
        // setVideoProgress()

        if (progress.percent === 100) {
            // clearInterval(this.updateVideoProgress)
            stopVideo()
        }
    }

    updateWidth = () => {
        const { style = { width: '401px' } } = this.props

        this.width = style.width.endsWith('%') ? this.context.width * (Number.parseInt(style.width) / 100) : style.width
    }

    updateProgress = x => {
        const { seekVideoProgress } = this.props
        const { marker } = this.refs
        // console.log('updateProgress')
        const percent = Math.round((x / (Number.parseInt(this.width) - this.props.markerWidth)) * 100.0)
        // console.log('percent', percent);
        // console.log('x', x);
        marker.setState({ x })
        seekVideoProgress(percent)
    }

    handleDrag = (e, ui) => {
        this.props.onChange && this.props.onChange(e)
    }

    handleDrop = (e, ui) => {
        this.updateProgress(ui.x)
    }

    handleOnProgressClick = e => {
        const { onChange } = this.props

        onChange && onChange(e)
        const mouse = e.pageX || e.touches[0].pageX
        const x = (this.refs.slider.getBoundingClientRect().left - mouse + this.props.markerWidth / 2) * -1
        this.updateProgress(x)
    }

    handleOnMouseUp = e => {
        // const { player, duration, percent } = this.props
        // const seconds = (percent / 100) * duration
        // this.progressClicked = false
        // player.seek(seconds || 0)
        // player.play()
    }

    handleOnBuffer = ({ buffered }) => {
        this.setState({ buffered: buffered * 100 })
    }

    render() {
        const { percent } = this.state
        const {
            style,
            height,
            markerWidth,
            markerHeight,
            markerTop,
            progress: {
                // percent,
                buffered,
                seconds,
                duration,
            },
        } = this.props

        const markerX = Math.round((percent * Number.parseInt(this.width)) / 100.0)
        const top = markerTop ? markerTop : -markerHeight / 2
        // only add mouseup event on desktop because the draggable
        // will be fighting with it
        const mouseTouchEvents = !isMobile
            ? {
                  onMouseUp: this.handleOnMouseUp,
              }
            : {}
        return (
            /* Scrub Bar Container */
            <div
                className={'video-ui-scrubbar'}
                style={Object.assign(
                    {},
                    { ...style, videoDuration: undefined },
                    {
                        width: this.width,
                        pointerEvents: 'all',
                    }
                )}
            >
                {/* Video Progress */}
                <div
                    className={'video-ui-progress'}
                    ref="slider"
                    onTouchStart={this.handleOnProgressClick}
                    onMouseDown={this.handleOnProgressClick}
                    {...mouseTouchEvents}
                    style={{
                        height,
                        position: 'relative',
                        cursor: 'pointer',
                        background: 'rgba(255,255,255,0.5)',
                        pointerEvents: 'all',
                    }}
                >
                    {/* Buffer Bar */}
                    <div
                        style={{
                            position: 'absolute',
                            height,
                            width: `${buffered}%`,
                            bottom: 0,
                            background: 'rgba(255,255,255,0.8)',
                        }}
                    />
                    {/* Bar */}
                    <div
                        style={{
                            position: 'absolute',
                            height,
                            width: `${percent}%`,
                            bottom: 0,
                            background: styleguide.colors['teal'],
                        }}
                    />
                    {/* Marker */}
                    <Draggable
                        ref="marker"
                        axis="x"
                        handle=".marker"
                        // Have to pass this in to trigger update for prop change
                        // DefaultPosition change not updating
                        key={markerX}
                        defaultPosition={{ x: markerX, y: 0 }}
                        onDrag={this.handleDrag}
                        onStop={this.handleDrop}
                        bounds={{
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                        }}
                    >
                        <div key={'markerKey'} className="marker" />
                    </Draggable>
                </div>

                {/* Video Duration Container */}
                <div
                    style={{
                        color: styleguide.colors['white'],
                        marginTop: 1,
                        fontSize: 16,
                        ...style.videoDuration,
                        padding: '10px 0',
                    }}
                >
                    {/*Current Time*/}
                    <div style={S.currentTime}>{VideoPlayer.toTime(seconds)}</div>

                    {/*Total Time*/}
                    <div style={S.totalTime}>{VideoPlayer.toTime(duration)}</div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ video }, { player }) => {
    return {
        // progress: video.getIn(['videoProgress']),
        // isVideoPlaying: video.getIn(['isVideoPlaying']),
        isVideoPlaying: false,
        player,
    }
}

const mapDispatchToProps = (dispatch, getState) => {
    return {
        // setVideoProgress: progress => dispatch(VideoPlayerActions.setVideoProgress(progress)),
        pauseVideo: () => dispatch(VideoPlayerActions.pauseVideo()),
    }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    // setVideoProgress: () => {
    //     const progress = stateProps.player.getProgressInfo()
    //     dispatchProps.setVideoProgress(progress)
    // },
    stopVideo: () => {
        stateProps.player.seek(0)
        // const progress = stateProps.player.getProgressInfo()
        // dispatchProps.pauseVideo()
        // dispatchProps.setVideoProgress(progress)
    },
    seekVideoProgress: percent => {
        const { player } = stateProps
        const progress = player.getProgressInfo()
        const seconds = (percent / 100) * progress.duration
        player.seek(seconds)
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(VideoScrubBar)
